/**
 * Contact display-name resolution for CRM UI (mirrors functions/contactNameUtils.js).
 */

function isPlaceholderFirstName(v) {
  return String(v || "").trim().toLowerCase() === "user";
}

function isWeakDisplayName(name, email) {
  const n = String(name || "").trim();
  if (!n) return true;
  if (isPlaceholderFirstName(n)) return true;
  const e = String(email || "").trim().toLowerCase();
  if (!e) return false;
  const local = e.split("@")[0] || "";
  if (n.toLowerCase() === e) return true;
  if (local && n.toLowerCase() === local.toLowerCase()) return true;
  return false;
}

function joinFirstLast(first, last) {
  const fn = String(first || "").trim();
  const ln = String(last || "").trim();
  const skipFn = !fn || isPlaceholderFirstName(fn);
  const parts = skipFn ? [ln] : [fn, ln];
  return parts.filter(Boolean).join(" ").trim();
}

export function resolveNameFromProfileDoc(data) {
  if (!data || typeof data !== "object") return "";
  const email = data.email || "";
  const direct = String(data.name || data.displayName || "").trim();
  if (direct && !isWeakDisplayName(direct, email)) return direct;
  const fromParts = joinFirstLast(
    data.first_name || data.firstName,
    data.last_name || data.lastName
  );
  if (fromParts && !isWeakDisplayName(fromParts, email)) return fromParts;
  return "";
}

export function resolveContactDisplayName(data) {
  if (!data || typeof data !== "object") return "Unknown";
  const fromProfile = resolveNameFromProfileDoc(data);
  if (fromProfile) return fromProfile;
  const email = data.email || "";
  if (email) {
    const local = String(email).split("@")[0] || "";
    if (local) return local;
  }
  return "Unknown";
}
